import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { Redirect } from 'react-router';
import QueryString from 'query-string';
import Swal from 'sweetalert2';

import { Button, Card, Col, Form, Row, Table } from 'react-bootstrap';
import {
    FaCheck,
    FaCheckCircle,
    FaClock,
    FaFileAlt,
    FaShare,
    FaTimes,
    FaTimesCircle
} from 'react-icons/fa';
import {
    CardBody,
    Container,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader
} from 'reactstrap';

import { ApplicationState } from '../../store';
import * as ApproveRejectWorkflowStore from '../../store/workflow/ApproveRejectWorkflow';
import * as SearchWorkflowDashboardStore from '../../store/workflow/SearchWorkflowDashboard';
import * as ModelApproveRejectWorkflow from '../../models/workflow/ApproveRejectWorkflow';
import * as ModelSearchWorkflowInbox from '../../models/workflow/SearchWorkflowInbox';
import * as ModelsWorkflowInbox from '../../models/workflow/WorkflowInbox';
import {
    formatDMY,
    formatYMDToDMY,
    numberWithCommas,
    onClickFileShow,
    onClickFileShowIframe,
    parseJwt
} from '../../modules/Common';
import { getCurrentTimestamp, safeParseJson } from '../../helpers/utils';
import { buildAttachmentDisplayList } from '../../helpers/attachmentUtils';
import { NewLineText } from '../../helpers/NewLineText';
import ApprovalInChargeStepper from 'common/components/ApprovalInChargeStepper';
import SignInComponent from '../auth/SignInComponent';

function isDMSFile(obj: any): obj is ModelSearchWorkflowInbox.File {
    return obj && 'file_name' in obj && 'file_path' in obj;
}

function WorkflowDashboardInformationDetailFn() {
    const dispatch = useDispatch();
    const location = useLocation();

    const searchworkflowDashboard = useSelector(
        (state: ApplicationState) => state.searchworkflowDashboard!
    );
    const approveRejectWorkflow = useSelector(
        (state: ApplicationState) => state.approveRejectWorkflow!
    );

    const {
        isLoadWorkflowInboxValue,
        statusWorkflowInboxValue,
        responseWorkflowInboxValue
    } = searchworkflowDashboard;

    const {
        isLoadApproveReject,
        statusResponseApproveReject,
        responseApproveReject,
        messageResponseApproveReject
    } = approveRejectWorkflow;

    const [userId, setUserId] = useState('');
    const [srcHistory] = useState(window.document.location.href);
    const [srcLogin, setSrcLogin] = useState('');
    const [loginModal, setLoginModal] = useState(false);
    const tokenRef = useRef('');

    const [workflowValueUse, setWorkflowValueUse] =
        useState<ModelsWorkflowInbox.WorkflowValue>({
            wfId: '',
            docNo: '',
            wfInstanceNo: '',
            userId: '',
            token: '',
            sid: '',
            appId: '',
            canReject: 'false'
        });

    const [formData, setFormData] = useState<any>([]);
    const [checkresponse, setCheckresponse] = useState(true);

    const [messageModal, setMessageModal] = useState(false);
    const [message, setMessage] = useState('');
    const [modeApproveReject, setModeApproveReject] = useState('');
    const [docNoList, setDocNoList] = useState<any[]>([]);
    const [successModal, setSuccessModal] = useState(false);
    const [successModalHeader, setSuccessModalHeader] = useState('');

    const [src, setSrc] = useState<string | undefined>(undefined);
    const [fileName, setFileName] = useState<string | undefined>(undefined);
    const [selectedFilePath, setSelectedFilePath] = useState<
        string | undefined
    >(undefined);

    const [displayApproveInChargeMode, setDisplayApproveInChargeMode] =
        useState<'step' | 'table'>('table');

    const checkresponseRef = useRef(true);
    const hasProcessedApproveRef = useRef(true);

    // ── Mount: resolve auth, parse URL, fire initial fetch ───────────────────
    useEffect(() => {
        const ls = localStorage.getItem('WF_APPLICATION');
        if (ls) {
            const jls = JSON.parse(ls);
            const at = parseJwt(jls.access_token);
            const extra = JSON.parse(at.extra);
            if (extra.citizen_id) {
                setUserId(extra.citizen_id);
                tokenRef.current = jls.access_token;
            } else if (extra.username) {
                setUserId(extra.username);
                tokenRef.current = jls.access_token;
            }
        }

        const query = QueryString.parse(location.search) as Record<
            string,
            string
        >;
        const {
            wfId,
            docNo,
            wfInstanceNo,
            userId: qUserId,
            token: qToken,
            app_id,
            ref_id,
            canReject
        } = query;

        // ref_id → redirect handled at render time
        if (ref_id) return;

        let resolvedAppId = app_id;
        if (!resolvedAppId && qToken) {
            try {
                const jToken = parseJwt(qToken);
                resolvedAppId = jToken.app;
            } catch {}
        }

        let resolvedUserId = qUserId;
        if (qToken) {
            try {
                const at = parseJwt(qToken);
                const extra = safeParseJson(at.extra);
                if (extra?.citizen_id) resolvedUserId = extra.citizen_id;
                else if (extra?.username) resolvedUserId = extra.username;
                tokenRef.current = qToken;
            } catch {}
        }

        setWorkflowValueUse({
            wfId,
            docNo,
            wfInstanceNo,
            userId: resolvedUserId,
            token: qToken,
            sid: resolvedAppId,
            appId: resolvedAppId,
            canReject: canReject
        });

        dispatch(
            SearchWorkflowDashboardStore.actionCreators.requestsearchworkflowDashboard(
                true,
                'POST',
                wfId,
                docNo,
                resolvedUserId,
                wfInstanceNo,
                qToken ?? '',
                resolvedAppId ?? ''
            )
        );
    }, []);

    // ── Handle data response ──────────────────────────────────────────────────
    useEffect(() => {
        if (!isLoadWorkflowInboxValue) return;

        if (
            statusWorkflowInboxValue === 200 &&
            responseWorkflowInboxValue != null &&
            checkresponseRef.current
        ) {
            checkresponseRef.current = false;
            setCheckresponse(false);
            setFormData(responseWorkflowInboxValue);
            const loaderEl =
                document.getElementsByClassName('Loader__background')[0];
            if (loaderEl) loaderEl.className = 'Loader__background hide';
            autoOpenFirstFile(responseWorkflowInboxValue);
        } else if (
            statusWorkflowInboxValue === 204 &&
            checkresponseRef.current
        ) {
            const loaderEl =
                document.getElementsByClassName('Loader__background')[0];
            if (loaderEl) loaderEl.className = 'Loader__background hide';
            dispatch(
                SearchWorkflowDashboardStore.actionCreators.requestsearchworkflowDashboard(
                    true,
                    'CLEAR',
                    workflowValueUse.wfId,
                    workflowValueUse.docNo,
                    workflowValueUse.userId,
                    workflowValueUse.wfInstanceNo,
                    '',
                    workflowValueUse.appId ?? ''
                )
            );
        }
    }, [searchworkflowDashboard]);

    // ── Handle approve / reject response ─────────────────────────────────────
    useEffect(() => {
        if (!isLoadApproveReject) return;
        if (hasProcessedApproveRef.current) return;

        if (statusResponseApproveReject === 200) {
            hasProcessedApproveRef.current = true;
            checkresponseRef.current = true;
            const loaderEl =
                document.getElementsByClassName('Loader__background')[0];
            if (loaderEl) loaderEl.className = 'Loader__background hide';
            setCheckresponse(true);
            setFormData([]);
            setMessageModal(false);
            setModeApproveReject('');
            setMessage('');
            setSuccessModal(true);
        } else if (statusResponseApproveReject === 400) {
            hasProcessedApproveRef.current = true;
            checkresponseRef.current = true;
            const loaderEl =
                document.getElementsByClassName('Loader__background')[0];
            if (loaderEl) loaderEl.className = 'Loader__background hide';
            setCheckresponse(true);
            setFormData([]);
            setMessageModal(false);
            setModeApproveReject('');
            setMessage('');

            dispatch(
                SearchWorkflowDashboardStore.actionCreators.requestsearchworkflowDashboard(
                    true,
                    'CLEAR',
                    workflowValueUse.wfId,
                    workflowValueUse.docNo,
                    workflowValueUse.userId,
                    workflowValueUse.wfInstanceNo,
                    '',
                    workflowValueUse.appId ?? ''
                )
            );
            dispatch(
                ApproveRejectWorkflowStore.actionCreators.requestApproveWorkflow(
                    true,
                    'CLEAR',
                    '',
                    '',
                    '',
                    ''
                )
            );
            dispatch(
                SearchWorkflowDashboardStore.actionCreators.requestsearchworkflowDashboard(
                    true,
                    'POST',
                    workflowValueUse.wfId,
                    workflowValueUse.docNo,
                    workflowValueUse.userId,
                    workflowValueUse.wfInstanceNo,
                    workflowValueUse.token ?? '',
                    workflowValueUse.appId ?? ''
                )
            );

            try {
                const msg = JSON.parse(messageResponseApproveReject ?? '');
                setTimeout(() => {
                    Swal.fire({
                        title: 'ไม่สำเร็จ!',
                        text: msg.message,
                        icon: 'error',
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'ตกลง',
                        allowOutsideClick: false
                    });
                }, 500);
            } catch {
                setTimeout(() => {
                    Swal.fire({
                        title: 'ไม่สำเร็จ!',
                        html: messageResponseApproveReject ?? '',
                        icon: 'error',
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'ตกลง',
                        allowOutsideClick: false
                    });
                }, 500);
            }
        }
    }, [approveRejectWorkflow]);

    // ── File helpers ──────────────────────────────────────────────────────────
    const autoOpenFirstFile = (data: any) => {
        const listDMS = safeParseJson<ModelSearchWorkflowInbox.File[]>(
            data['listDMS']
        );
        const listFileUrl = safeParseJson<ModelSearchWorkflowInbox.FileUrl[]>(
            data['listFileUrl']
        );
        const fileList = [...(listDMS ?? []), ...(listFileUrl ?? [])].filter(
            (f?: object) => f && Object.keys(f).length > 0
        );
        if (fileList.length === 0) return;

        const { file: firstFile, displayName: firstFileName } =
            buildAttachmentDisplayList(fileList)[0];
        const filePath = isDMSFile(firstFile)
            ? firstFile.file_path
            : (firstFile as ModelSearchWorkflowInbox.FileUrl).url;
        const mode = isDMSFile(firstFile) ? '' : 's3';
        if (!firstFile.file_name || !filePath) return;

        const syntheticEvent = {
            target: {
                dataset: { filepath: filePath, filename: firstFile.file_name }
            }
        };
        onClickFileShowIframe(syntheticEvent, mode, tokenRef.current)
            .then((iframeSrc: string | undefined) => {
                if (!iframeSrc) return;
                setSrc(iframeSrc + `&timestamp=${getCurrentTimestamp()}`);
                setFileName(firstFileName);
                setSelectedFilePath(filePath);
            })
            .catch(() => {});
    };

    const handleClickFileShowIframe = (
        e: any,
        clickedFileName: any,
        mode: any,
        clickedFilePath?: string
    ) => {
        onClickFileShowIframe(e, mode, tokenRef.current).then(
            (iframeSrc: string | undefined) => {
                if (!iframeSrc) return;
                setSrc(iframeSrc + `&timestamp=${getCurrentTimestamp()}`);
                setFileName(clickedFileName);
                setSelectedFilePath(clickedFilePath);
            }
        );
    };

    const handleClickFileShowFile = (
        e: any,
        clickedFileName: any,
        filePath: any,
        mode: any
    ) => {
        e.target.dataset.filepath = filePath;
        e.target.dataset.filename = clickedFileName;
        e.target.dataset.mode = mode;
        onClickFileShow(e, tokenRef.current);
    };

    const handleCloseFile = () => {
        setSrc(undefined);
        setFileName(undefined);
        setSelectedFilePath(undefined);
    };

    // ── Approve / Reject handlers ─────────────────────────────────────────────
    const handleMessage = () => {
        if (messageModal) {
            setMessageModal(false);
            setModeApproveReject('');
            setMessage('');
            setDocNoList([]);
        } else {
            setMessageModal(true);
        }
    };

    const handleSuccessModal = () => {
        const loaderEl =
            document.getElementsByClassName('Loader__background')[0];
        if (loaderEl) loaderEl.className = 'Loader__background hide';
        if (successModal) {
            dispatch(
                ApproveRejectWorkflowStore.actionCreators.requestApproveWorkflow(
                    true,
                    'CLEAR',
                    '',
                    '',
                    '',
                    ''
                )
            );
            setSuccessModal(false);
            setSuccessModalHeader('');
            window.location.reload();
        } else {
            setSuccessModal(true);
        }
    };

    const handleLoginModal = () => setLoginModal(prev => !prev);

    const blindLogin = () => setLoginModal(false);

    const onchangeMessage = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setMessage(e.target.value);
    };

    const onsuccessApproveReject = () => {
        const escapedMessage = message.replace(/[']/g, "''");
        const loaderEl =
            document.getElementsByClassName('Loader__background')[0];
        if (loaderEl) loaderEl.className = 'Loader__background show';

        const updatedList = docNoList.map((item: any) => ({
            ...item,
            message: escapedMessage
        }));
        setDocNoList(updatedList);
        hasProcessedApproveRef.current = false;

        if (modeApproveReject === 'approved') {
            dispatch(
                ApproveRejectWorkflowStore.actionCreators.requestApproveWorkflowList(
                    true,
                    'PUT',
                    updatedList,
                    escapedMessage
                )
            );
        } else {
            dispatch(
                ApproveRejectWorkflowStore.actionCreators.requestRejectWorkflowList(
                    true,
                    'PUT',
                    updatedList,
                    escapedMessage
                )
            );
        }
    };

    const handleApprove = (
        wfInstanceNo: string,
        docNo: string,
        docUserId: string,
        wfType: string,
        sid: string
    ) => {
        setDocNoList([
            {
                app_id: sid,
                user_id: docUserId,
                admin_user_id: userId,
                wf_type: wfType,
                doc_no_list: [docNo],
                instance_no_list: [wfInstanceNo]
            }
        ]);
        setSuccessModalHeader('Approved Status');
        setMessageModal(true);
        setModeApproveReject('approved');
    };

    const handleReject = (
        wfInstanceNo: string,
        docNo: string,
        docUserId: string,
        wfType: string,
        sid: string
    ) => {
        setDocNoList([
            {
                app_id: sid,
                user_id: docUserId,
                admin_user_id: userId,
                wf_type: wfType,
                doc_no_list: [docNo],
                instance_no_list: [wfInstanceNo]
            }
        ]);
        setSuccessModalHeader('Rejected Status');
        setMessageModal(true);
        setModeApproveReject('reject');
    };

    // ── Early redirects ───────────────────────────────────────────────────────
    const query = QueryString.parse(location.search) as Record<string, string>;
    if (query.ref_id) {
        return (
            <Redirect to={'/workflow-report-overview?ref_id=' + query.ref_id} />
        );
    }
    if (loginModal) {
        return (
            <Redirect
                to={{ pathname: '/auth/signin', state: { from: srcHistory } }}
            />
        );
    }

    // ── Derived render values ─────────────────────────────────────────────────
    const listDMS = safeParseJson<ModelSearchWorkflowInbox.File[]>(
        formData['listDMS']
    );
    const listFileUrl = safeParseJson<ModelSearchWorkflowInbox.FileUrl[]>(
        formData['listFileUrl']
    );
    const fileList = [...(listDMS ?? []), ...(listFileUrl ?? [])].filter(
        (file?: object) => file && Object.keys(file).length > 0
    );
    const hasSrc = src !== undefined;

    // ── Attachment list ───────────────────────────────────────────────────────
    const attachmentListJSX =
        fileList.length === 0 ? (
            <p className="text-muted mb-0">
                ผู้ขออนุมัติยืนยันส่ง Workflow โดยไม่มีไฟล์แนบ
            </p>
        ) : (
            <table>
                <tbody>
                    {buildAttachmentDisplayList(fileList).map(
                        ({ file, displayName, rowKey }) => {
                            const fName = file.file_name;
                            const filePath = isDMSFile(file)
                                ? file.file_path
                                : (file as ModelSearchWorkflowInbox.FileUrl)
                                      .url;
                            return file &&
                                (fName != null || filePath != null) ? (
                                <tr key={rowKey}>
                                    <td>
                                        <a
                                            href="javascript:void(0);"
                                            data-filename={fName}
                                            data-filepath={filePath}
                                            onClick={e =>
                                                handleClickFileShowFile(
                                                    e,
                                                    fName,
                                                    filePath,
                                                    !isDMSFile(file) && 's3'
                                                )
                                            }
                                        >
                                            <FaShare
                                                style={{
                                                    transform: 'rotate(270deg)',
                                                    color: 'green'
                                                }}
                                            />
                                        </a>
                                        &nbsp;
                                    </td>
                                    <td>
                                        <a
                                            href="javascript:void(0);"
                                            data-filename={fName}
                                            data-filepath={filePath}
                                            onClick={e =>
                                                handleClickFileShowIframe(
                                                    e,
                                                    displayName,
                                                    !isDMSFile(file) && 's3',
                                                    filePath
                                                )
                                            }
                                            style={{
                                                fontWeight:
                                                    selectedFilePath ===
                                                    filePath
                                                        ? 'bold'
                                                        : 'normal'
                                            }}
                                        >
                                            <FaFileAlt />
                                            &nbsp;{displayName}
                                        </a>
                                    </td>
                                </tr>
                            ) : null;
                        }
                    )}
                </tbody>
            </table>
        );

    // ── Approver table ────────────────────────────────────────────────────────
    const approverTableJSX = (
        <>
            {displayApproveInChargeMode === 'step' ? (
                <ApprovalInChargeStepper
                    document={
                        formData as unknown as ModelSearchWorkflowInbox.ResponseWorkflowInboxValue
                    }
                />
            ) : (
                <Table
                    responsive
                    hover
                    size="lg"
                    className="table-bordered mt-2"
                >
                    <thead>
                        <tr className="table-active text-center">
                            <th style={{ width: '2%' }}></th>
                            <th style={{ width: '20%' }}>Approver Code</th>
                            <th style={{ width: '20%' }}>Approver Name</th>
                            <th style={{ width: '10%' }}>สถานะ</th>
                            <th style={{ width: '28%' }}>Description</th>
                            <th style={{ width: '25%' }}>Approve Date/Time</th>
                        </tr>
                    </thead>
                    {!checkresponse &&
                        formData['listApprovalDetail']?.map(
                            (
                                item: ModelSearchWorkflowInbox.WorkflowInboxValue,
                                idx: number
                            ) => (
                                <tbody key={idx}>
                                    <tr
                                        key={'1-' + idx}
                                        style={
                                            item.status === 'APPROVED'
                                                ? {
                                                      backgroundColor: '#90be6d'
                                                  }
                                                : item.status === 'CANCEL'
                                                ? {
                                                      backgroundColor: '#e5383b'
                                                  }
                                                : {
                                                      backgroundColor: '#f8f9fa'
                                                  }
                                        }
                                    >
                                        <td>{idx + 1}</td>
                                        <td>{item.positiongroupname}</td>
                                        <td>
                                            {item.status === 'APPROVED' ||
                                            item.status === 'CANCEL'
                                                ? item.updated_byname
                                                : ''}
                                        </td>
                                        <td className="text-center">
                                            {item.status === 'APPROVED' ? (
                                                <FaCheck />
                                            ) : item.status === 'CANCEL' ? (
                                                <FaTimes />
                                            ) : (
                                                <FaClock />
                                            )}
                                        </td>
                                        <td>
                                            {item.status === 'APPROVED' ||
                                            item.status === 'CANCEL'
                                                ? item.reason
                                                : ''}
                                        </td>
                                        <td>
                                            {item.status === 'APPROVED' ||
                                            item.status === 'CANCEL'
                                                ? formatDMY(
                                                      String(
                                                          item.updatedOnFormatDateTime
                                                      )
                                                  )
                                                : ''}
                                        </td>
                                    </tr>
                                    <tr key={'2-' + idx}>
                                        <td></td>
                                        <td colSpan={5}>
                                            <table
                                                style={{ width: '100%' }}
                                                className="table-borderless"
                                            >
                                                {!checkresponse &&
                                                    formData[
                                                        'listApprovalDetail'
                                                    ][idx][
                                                        'listEmployeeInPositionGroup'
                                                    ]?.map(
                                                        (
                                                            subitem: ModelSearchWorkflowInbox.listEmployeeInPositionGroup,
                                                            subidx: number
                                                        ) => (
                                                            <tbody key={subidx}>
                                                                <tr
                                                                    key={subidx}
                                                                >
                                                                    <td
                                                                        style={{
                                                                            width: '20%'
                                                                        }}
                                                                    >
                                                                        {
                                                                            subitem.empid
                                                                        }
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            width: '20%'
                                                                        }}
                                                                    >
                                                                        {
                                                                            subitem.empname
                                                                        }
                                                                    </td>
                                                                    <td
                                                                        className="text-center"
                                                                        style={{
                                                                            width: '10%'
                                                                        }}
                                                                    ></td>
                                                                    <td
                                                                        style={{
                                                                            width: '30%'
                                                                        }}
                                                                    ></td>
                                                                    <td
                                                                        style={{
                                                                            width: '25%'
                                                                        }}
                                                                    ></td>
                                                                </tr>
                                                            </tbody>
                                                        )
                                                    )}
                                            </table>
                                        </td>
                                    </tr>
                                </tbody>
                            )
                        )}
                </Table>
            )}
        </>
    );

    // ── Form fields card ──────────────────────────────────────────────────────
    const formFieldsJSX = (
        <Card>
            <Card.Body>
                <table className="w-full text-left">
                    <tbody>
                        <tr>
                            <td
                                className="whitespace-nowrap"
                                style={{
                                    width: '20%',
                                    verticalAlign: 'top'
                                }}
                            >
                                <label>
                                    <b>Subject :</b>
                                </label>
                            </td>
                            <td>{formData['subject']}</td>
                        </tr>
                        <tr>
                            <td
                                className="whitespace-nowrap"
                                style={{ width: '20%' }}
                            >
                                <label>
                                    <b>Document Type :</b>
                                </label>
                            </td>
                            <td>{formData['docType']}</td>
                        </tr>
                        <tr>
                            <td
                                className="whitespace-nowrap"
                                style={{ width: '20%' }}
                            >
                                <label>
                                    <b>Document No. :</b>
                                </label>
                            </td>
                            <td>{formData['docNo']}</td>
                        </tr>
                        {formData['refDoc'] && (
                            <tr>
                                <td
                                    className="whitespace-nowrap"
                                    style={{ width: '20%' }}
                                >
                                    <label>
                                        <b>Document Reference :</b>
                                    </label>
                                </td>
                                <td>{formData['refDoc']}</td>
                            </tr>
                        )}
                        {formData['projectName'] && (
                            <tr>
                                <td
                                    className="whitespace-nowrap"
                                    style={{ width: '20%' }}
                                >
                                    <label>
                                        <b>Project Name :</b>
                                    </label>
                                </td>
                                <td>
                                    {NewLineText(
                                        formData['projectName'],
                                        '<br/>'
                                    )}
                                </td>
                            </tr>
                        )}
                        {formData['jobName'] && (
                            <tr>
                                <td
                                    className="whitespace-nowrap"
                                    style={{ width: '20%' }}
                                >
                                    <label>
                                        <b>Job Name :</b>
                                    </label>
                                </td>
                                <td>{formData['jobName']}</td>
                            </tr>
                        )}
                        <tr>
                            <td
                                className="whitespace-nowrap"
                                style={{ width: '20%' }}
                            >
                                <label>
                                    <b>Year :</b>
                                </label>
                            </td>
                            <td>{formData['docYear']}</td>
                        </tr>
                        <tr>
                            <td
                                className="whitespace-nowrap"
                                style={{ width: '20%' }}
                            >
                                <label>
                                    <b>Document Date :</b>
                                </label>
                            </td>
                            <td>
                                {!checkresponse
                                    ? formatYMDToDMY(
                                          String(formData['docDate'])
                                      )
                                    : ''}
                            </td>
                        </tr>
                        <tr>
                            <td
                                className="whitespace-nowrap"
                                style={{ width: '20%' }}
                            >
                                <label>
                                    <b>Bussiness Partner :</b>
                                </label>
                            </td>
                            <td>{formData['bussinessPartner']}</td>
                        </tr>
                        <tr>
                            <td
                                className="whitespace-nowrap"
                                style={{ width: '20%' }}
                            >
                                <label>
                                    <b>Vendor Landed Cost in PO :</b>
                                </label>
                            </td>
                            <td>{formData['vendorLandedcost']}</td>
                        </tr>
                        <tr>
                            <td
                                className="whitespace-nowrap"
                                style={{ width: '20%' }}
                            >
                                <label>
                                    <b>Source System Information :</b>
                                </label>
                            </td>
                            <td>
                                <a
                                    href={formData['refUrl']}
                                    target="_blank"
                                    className="cursor-pointer text-[#0366d6]"
                                >
                                    {formData['refUrl']
                                        ? 'กดที่นี่ เพื่อพาคุณไปดูข้อมูลบนระบบ'
                                        : ''}
                                </a>
                            </td>
                        </tr>
                        <tr>
                            <td
                                className="whitespace-nowrap"
                                style={{ width: '20%' }}
                            >
                                <label>
                                    <b>Requestor :</b>
                                </label>
                            </td>
                            <td>{formData['requestorName']}</td>
                        </tr>
                        <tr>
                            <td
                                className="whitespace-nowrap"
                                style={{ width: '20%' }}
                            >
                                <label>
                                    <b>Requestor Amount :</b>
                                </label>
                            </td>
                            <td>
                                {numberWithCommas(formData['docAmount'])}
                                &nbsp;{formData['docCurrency']}
                            </td>
                        </tr>
                        <tr>
                            <td
                                className="whitespace-nowrap"
                                style={{ width: '20%' }}
                            >
                                <label>
                                    <b>Current approval :</b>
                                </label>
                            </td>
                            <td>
                                {formData['curtaskid'] +
                                    '/' +
                                    formData['maxtaskid']}
                            </td>
                        </tr>
                        <tr>
                            <td
                                className="whitespace-nowrap"
                                style={{
                                    width: '20%',
                                    verticalAlign: 'top'
                                }}
                            >
                                <label>
                                    <b>Message from requested :</b>
                                </label>
                            </td>
                            <td style={{ whiteSpace: 'pre-line' }}>
                                {formData['requestorMessage']}
                            </td>
                        </tr>
                        <tr>
                            {fileList.length === 0 ? (
                                <td className="whitespace-nowrap">
                                    <label>
                                        <b>
                                            ผู้ขออนุมัติยืนยันส่ง Workflow
                                            โดยไม่มีไฟล์แนบ
                                        </b>
                                    </label>
                                </td>
                            ) : (
                                <>
                                    <td
                                        className="whitespace-nowrap"
                                        style={{ width: '20%' }}
                                    >
                                        <label>
                                            <b>Document Attachment :</b>
                                        </label>
                                    </td>
                                    <td>{attachmentListJSX}</td>
                                </>
                            )}
                        </tr>
                    </tbody>
                </table>
            </Card.Body>
        </Card>
    );

    // ── Main render ───────────────────────────────────────────────────────────
    return (
        <Container
            fluid={true}
            className="mt-3"
        >
            {/* Approve / Reject buttons */}
            {/* <Row>
                <Col>
                    <Button
                        variant="outline-success mx-1"
                        size="sm"
                        onClick={() =>
                            handleApprove(
                                workflowValueUse.wfInstanceNo,
                                workflowValueUse.docNo,
                                workflowValueUse.userId,
                                formData['wfType'],
                                workflowValueUse.appId ?? ''
                            )
                        }
                    >
                        <FaCheck />
                        &nbsp;Approve
                    </Button>
                    <Button
                        variant="outline-danger mx-1"
                        size="sm"
                        onClick={() =>
                            handleReject(
                                workflowValueUse.wfInstanceNo,
                                workflowValueUse.docNo,
                                workflowValueUse.userId,
                                formData['wfType'],
                                workflowValueUse.appId ?? ''
                            )
                        }
                    >
                        <FaTimesCircle />
                        &nbsp;Reject
                    </Button>
                </Col>
            </Row> */}

            {hasSrc ? (
                /* Split layout */
                <Row
                    className="mt-3"
                    style={{ minHeight: '80vh' }}
                >
                    <Col
                        lg={6}
                        style={{
                            borderRight: '1px solid #dee2e6',
                            overflowY: 'auto',
                            maxHeight: '80vh',
                            paddingRight: '12px'
                        }}
                    >
                        <Card>
                            <Card.Header>
                                <span
                                    className="text-truncate"
                                    style={{
                                        maxWidth: '80%',
                                        display: 'inline-block'
                                    }}
                                >
                                    {fileName}
                                </span>
                                <span style={{ float: 'right' }}>
                                    <Button
                                        size="sm"
                                        variant="outline-danger"
                                        onClick={handleCloseFile}
                                    >
                                        <FaTimes
                                            size={15}
                                            color="red"
                                        />
                                        &nbsp;ปิด
                                    </Button>
                                </span>
                            </Card.Header>
                            <Card.Body style={{ padding: 0 }}>
                                <iframe
                                    src={`${src}#navpanes=0`}
                                    style={{
                                        minHeight: '900px',
                                        display: 'block',
                                        border: 'none'
                                    }}
                                    height="100%"
                                    width="100%"
                                    frameBorder="0"
                                    title="PDF Preview"
                                />
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col
                        lg={6}
                        style={{
                            overflowY: 'auto',
                            maxHeight: '80vh',
                            paddingLeft: '12px'
                        }}
                    >
                        {formFieldsJSX}
                    </Col>
                </Row>
            ) : (
                /* Normal layout */
                <Row className="mt-3">
                    <Col>{formFieldsJSX}</Col>
                </Row>
            )}

            <Row className="mt-3">
                <Col>{approverTableJSX}</Col>
            </Row>

            {/* Message / confirm modal */}
            <Modal
                isOpen={messageModal}
                toggle={handleMessage}
                size="lg"
                backdrop="static"
                keyboard={false}
            >
                <ModalHeader toggle={handleMessage}>Message</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col>
                            <Form.Group controlId="dashboardDetailFnMessageTextarea">
                                <Form.Control
                                    as="textarea"
                                    rows={5}
                                    onChange={onchangeMessage}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button
                        className="bg-[#17a2b8]"
                        variant="info"
                        onClick={onsuccessApproveReject}
                    >
                        Confirm
                    </Button>
                    <Button
                        className="bg-[#6c757d]"
                        variant="secondary"
                        onClick={handleMessage}
                    >
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>

            {/* Success / result modal */}
            <Modal
                isOpen={successModal}
                toggle={handleSuccessModal}
                size="lg"
                backdrop="static"
                keyboard={false}
            >
                {isLoadApproveReject &&
                    statusResponseApproveReject === 200 &&
                    responseApproveReject != null &&
                    Array.isArray(responseApproveReject['result_list']) &&
                    responseApproveReject['result_list'].map(
                        (
                            item: ModelApproveRejectWorkflow.ApproveRejectWorkflowResponse,
                            idx: number
                        ) => {
                            if (
                                item.status === 'wait_otp' ||
                                item.status === 'wait_sign'
                            ) {
                                window.location.replace(item.redirectLink);
                                return null;
                            }
                            return (
                                <React.Fragment key={idx}>
                                    <ModalHeader toggle={handleSuccessModal}>
                                        {successModalHeader}
                                    </ModalHeader>
                                    <ModalBody scrollable>
                                        <Row>
                                            <Col>
                                                <Card className="mb-1 rounded bg-white p-1 shadow-sm">
                                                    <CardBody>
                                                        <Row>
                                                            <Col
                                                                lg={2}
                                                                className="text-center"
                                                            >
                                                                {item.status ===
                                                                'SUCCESS' ? (
                                                                    <FaCheckCircle
                                                                        size={
                                                                            50
                                                                        }
                                                                        color="green"
                                                                    />
                                                                ) : (
                                                                    <FaTimesCircle
                                                                        size={
                                                                            80
                                                                        }
                                                                        color="red"
                                                                        style={{
                                                                            paddingTop:
                                                                                '30px'
                                                                        }}
                                                                    />
                                                                )}
                                                            </Col>
                                                            <Col lg={10}>
                                                                <Table
                                                                    className="table-borderless table-hover table"
                                                                    size="sm"
                                                                >
                                                                    <tr className="require-field">
                                                                        <td
                                                                            className="font-weight-bold"
                                                                            style={{
                                                                                width: '30%'
                                                                            }}
                                                                        >
                                                                            Document
                                                                            NO.
                                                                            :
                                                                        </td>
                                                                        <td
                                                                            style={{
                                                                                width: '70%'
                                                                            }}
                                                                        >
                                                                            {
                                                                                item.docNo
                                                                            }
                                                                        </td>
                                                                    </tr>
                                                                    <tr className="require-field">
                                                                        <td
                                                                            className="font-weight-bold"
                                                                            style={{
                                                                                width: '30%'
                                                                            }}
                                                                        >
                                                                            Status
                                                                            :
                                                                        </td>
                                                                        <td
                                                                            style={{
                                                                                width: '70%'
                                                                            }}
                                                                        >
                                                                            {
                                                                                item.status
                                                                            }
                                                                        </td>
                                                                    </tr>
                                                                    <tr className="require-field">
                                                                        <td
                                                                            className="font-weight-bold"
                                                                            style={{
                                                                                width: '30%'
                                                                            }}
                                                                        >
                                                                            Message
                                                                            :
                                                                        </td>
                                                                        <td
                                                                            style={{
                                                                                width: '70%'
                                                                            }}
                                                                        >
                                                                            {
                                                                                item.message
                                                                            }
                                                                        </td>
                                                                    </tr>
                                                                    {item.status ===
                                                                        'error' && (
                                                                        <tr className="require-field">
                                                                            <td
                                                                                className="font-weight-bold"
                                                                                style={{
                                                                                    width: '30%'
                                                                                }}
                                                                            >
                                                                                Error
                                                                                Message
                                                                                :
                                                                            </td>
                                                                            <td
                                                                                style={{
                                                                                    width: '70%'
                                                                                }}
                                                                            >
                                                                                {
                                                                                    item.errorMessage
                                                                                }
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                                </Table>
                                                            </Col>
                                                        </Row>
                                                    </CardBody>
                                                </Card>
                                            </Col>
                                        </Row>
                                    </ModalBody>
                                    <ModalFooter>
                                        <Button
                                            className="bg-[#dc3545]"
                                            variant="danger"
                                            onClick={handleSuccessModal}
                                            disabled={
                                                item.status === 'wait_otp'
                                            }
                                        >
                                            Close
                                        </Button>
                                    </ModalFooter>
                                </React.Fragment>
                            );
                        }
                    )}
            </Modal>

            {/* Login modal */}
            <Modal
                isOpen={loginModal}
                toggle={handleLoginModal}
                size="xl"
                backdrop="static"
                keyboard={false}
            >
                <ModalBody>
                    <SignInComponent
                        AnonymousMode={loginModal}
                        blindLogin={blindLogin}
                    />
                    <iframe
                        style={{
                            WebkitWritingMode: 'vertical-lr',
                            overflow: 'none'
                        }}
                        src={srcLogin}
                        name="myIframe"
                        height="70%"
                        width="100%"
                        title="Iframe Example"
                        frameBorder="0"
                    />
                </ModalBody>
            </Modal>
        </Container>
    );
}

export default WorkflowDashboardInformationDetailFn;
